import React, { useEffect } from "react";
import {UsuarioContext} from '../../contexts/UsuarioContext';
import {useSessionStore} from '../../hooks/useSessionStore';
import { useState } from "react";
import HeaderHome from "../../components/headerHome/HeaderHome";
import { MiFooter } from "../../components/footer/MiFooter";
import 'bootstrap/dist/css/bootstrap.min.css';
import './FormularioValoraviones.css'
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useLocation } from "react-router-dom";

export const FormularioValoraciones = (props) => {
    const {empresa_id} = props;
    const [MenuLateralAux, setMenuLateralAux] = useState();

    const [Usuario, setUsuario] = useSessionStore(UsuarioContext);
    const [empresa, setEmpresa] = useState();

    const navigate = useNavigate()

    const [puntuacion, setPuntuacion] = useState(5)
    const [comentario, setComentario] = useState('')

    const [mensaje, setMensaje] = useState('')

    
    const {state} = useLocation()

    useEffect(()=>{
        setEmpresa(state)
    },[state])

    const chageMenuLateralAux = () => {
        setMenuLateralAux(!MenuLateralAux)
    }

    const handleInput = (e) => {
        setPuntuacion(e.target.value)
    }

    const handleArea = (e) => {
        setComentario(e.target.value)
    }

    const enviarReseña = () => {
        let data = {
            valoracion: puntuacion,
            comentario: comentario,
            empresa_id: empresa.empresa_id
        }
        axios({
            method: 'post',
            url: window.ipdirection + 'anadirResena/',
            headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
            data:data
        }).then((response)=>{
            document.getElementById('text-msg').classList.add('color-green')
            setMensaje('Valoración enviada con éxito')
        }).catch((error)=>{
            document.getElementById('text-msg').classList.add('color-red')
            setMensaje('No se ha podido enviar su valoración')
        })
    }
    

    return (
        <>
            <div className='PerfilAgencia'>
                <div className='headerPerfilAgencia'>
                    <HeaderHome 
                        chageMenuLateralAux={chageMenuLateralAux}
                    />
                </div>
                <div className="bodyPerfil-agencia">
                    <div className='content-body-perfil-agencia-nuevo'>
                        <div className='info-perfil-agencia-nuevo'>
                            <div className='descripcion-perfil-agencia centrador descripcion-servicio flecha'>
                                <div className='centrador menu-header' onClick={()=>{navigate('/monitorCuidados')}}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H6M12 5l-7 7 7 7"/></svg>
                                </div>
                            </div>
                        </div>
                        <div className="bloque-valoraciones">
                            <div className='bloque-titulo'>
                                <h2>¿Qué le ha parecido el servicio?</h2>
                            </div>
                            <div className="bloque-puntuacion">
                                <input type="range" class="form-range range-color" min="0" max="5" id="customRange3"
                                    onChange={(e)=>handleInput(e)}
                                />
                                <div className="label">
                                    <span><strong>{puntuacion}</strong>/5</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
                                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"></path>
                                    </svg>
                                </div>
                            </div>
                            <div className="bloque-comentario">
                                <p>Deje aquí su comentario:</p>
                                <textarea class="form-control textarea-comentario" placeholder="Leave a comment here" id="floatingTextarea2"
                                    value={comentario}
                                    onChange={(e)=>handleArea(e)}
                                />
                            </div>
                            <div class="button boton-valorar" onClick={()=>{enviarReseña()}}>
                                <div><b>Enviar</b></div>
                            </div>
                            <div id="text-msg" className="bloque-mensaje text-muted container-fluid">
                                {mensaje}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='footerPerfilAgencia'>
                    <MiFooter />
                </div>
            </div>
        </>
    )
}